import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${p => p.bg || '#000'};
  padding: 60px 24px;
`;

export const Container = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  color: ${p => p.color || '#fff'};
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 32px;
`;

export const Section = styled.section`
  margin-bottom: 40px;
`;

export const SectionTitle = styled.h2`
  color: ${p => p.accent || '#667eea'};
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
`;

export const TipList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TipItem = styled.li`
  color: ${p => p.color || '#fff'}cc;
  font-size: 14px;
  line-height: 1.6;
`;
